import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BancoPlazaService } from '../../../services/banco-plaza.service';
import Swal from 'sweetalert2';

/**
 * Modal para administrar `BANCO_PLAZA_MONTO_MIN` (tope nominal VES para que
 * BP procese un payout). Espejo de `N58MontoMinModalComponent`.
 */
@Component({
  selector: 'app-banco-plaza-monto-min-modal',
  templateUrl: './banco-plaza-monto-min-modal.component.html',
})
export class BancoPlazaMontoMinModalComponent implements OnInit {
  form: FormGroup;
  loading = false;
  loadingActual = true;
  valorActual: number | null = null;

  constructor(
    private bp: BancoPlazaService,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<BancoPlazaMontoMinModalComponent>,
  ) {
    this.form = this.fb.group({
      valor: new FormControl(null, [
        Validators.required,
        Validators.min(1),
        Validators.pattern(/^[0-9]+$/),
      ]),
    });
  }

  ngOnInit(): void {
    this.bp.getBPMontoMin().subscribe({
      next: (res) => {
        this.valorActual = res?.valor ?? null;
        if (this.valorActual !== null && this.valorActual > 0) {
          this.form.patchValue({ valor: this.valorActual });
        }
        this.loadingActual = false;
      },
      error: () => {
        this.loadingActual = false;
      },
    });
  }

  formatVES(amount: number | null | undefined): string {
    if (amount === null || amount === undefined) return '-';
    return new Intl.NumberFormat('es-VE', {
      style: 'currency',
      currency: 'VES',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  }

  guardar(): void {
    if (this.form.invalid || this.loading) return;

    const raw = this.form.get('valor')?.value;
    const valor = parseInt(String(raw), 10);
    if (!Number.isInteger(valor) || valor <= 0) {
      Swal.fire({
        icon: 'error',
        title: 'Valor inválido',
        text: 'El monto mínimo debe ser un número entero positivo (sin puntos ni decimales).',
        confirmButtonColor: '#1C593D',
      });
      return;
    }

    this.loading = true;
    this.bp.setBPMontoMin(valor).subscribe({
      next: (res) => {
        const nuevo = res?.montoMin ?? valor;
        Swal.fire({
          icon: 'success',
          title: 'Monto mínimo BP actualizado',
          html: `<p>Nuevo valor: <strong>${this.formatVES(nuevo)}</strong></p>`,
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#1C593D',
        });
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.loading = false;
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text:
            err?.error?.message ||
            err?.message ||
            String(err) ||
            'No se pudo actualizar el monto mínimo',
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#1C593D',
        });
      },
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
